import { Component } from 'react'
import { promoCodeManager } from 'services/PromoCodeManager'
import {
  DISCOUNT_TYPES,
  PROMO_CODE_SOURCE,
  WELCOME_COUPON,
} from '../../../stores/promoCodeStore/promoCode.consts'
import DeliveryPromiseItem from './SummaryItems/DeliveryPromiseItem'
import BuyOverMissingTiles from './SummaryItems/PromoCodesSummaryItems/BuyOverMissingTiles'
import TilesToAddForFreeShipping from './SummaryItems/TilesToAddForFreeShipping'
import FreeTilesSummaryItem from './SummaryItems/PromoCodesSummaryItems/FreeTilesSummaryItem'
import TotalPriceSummaryItem from './SummaryItems/TotalPriceSummaryItem'
import {
  renderAdditionalTilesPriceForMinOrderSize,
  renderAdditionalTilesPriceForVariesPricingType,
  renderBaseTilesPriceForVariesPricingType,
  renderMinOrderSizeLineItem,
  getDiscountDescription,
  getTilesCreditsCouponDescription,
  getGiftCardCreditsDescription,
  getGiftCardDescription,
} from './OrderSummaryUtils'
import {
  isBookCreditsCoupon,
  isGiftCardOrder,
} from '../../../pages/GiftCard/utils'
import { translateManager as t } from 'services/TranslateManager'
import AddPromoCode from './SummaryItems/AddPromoCode/AddPromoCode'
import { getOrderSummarySizeText, getSizeName } from 'services/SizesManager'
import PriceWithCrossedDiscount from './SummaryItems/PromoCodesSummaryItems/PriceWithCrossedDiscount/PriceWithCrossedDiscount'
import CenterpiecesSummaryItem from './SummaryItems/CenterpiecesSummaryItem'
import {
  getTileMaterialType,
  getTilesMaterials,
} from '../../../services/tileMaterial'
import {
  isCenterpiece,
  MATERIAL_TYPES,
  ProductIds,
  FRAME_COLORS,
} from '@mixtiles/web-backend-shared'
import SheetButton from '../../SheetButton/SheetButton'
import PromoCodeDialog from '../../PromoCodeDialog/PromoCodeDialog.client'
import { analytics, EVENT_NAMES } from '../../../services/Analytics/Analytics'
import * as S from './PhotosOrderSummary.styles'
import Divider from '../../../pages/HomePage/Components/Divider/Divider'
import { withProductType } from '../../../services/ProductTypesManager'
import MinimumOrderFeeSummaryItem from './SummaryItems/MinimumOrderFeeSummaryItem/MinimumOrderFeeSummaryItem'
import GiftCardCreditsItem from './SummaryItems/GiftCardCreditsItem/GiftCardCreditsItem'
import ConfirmationPopup from '../../ConfirmationPopup/ConfirmationPopup'
import { withDialog } from '../../../elements/Dialog/DialogProvider'
import { withPricing } from '../../Pricing/PricingProvider'
import ProductSummaryItem from './SummaryItems/ProductSummaryItem/ProductSummaryItem'
import { withPhotoBookSummaryData } from '../../PhotoBook/withPhotoBookSummaryData'
import {
  MIXED_MATERIALS,
  MIXED_SIZES,
} from '../../../pages/PhotoStyler/TileDesignerConsts'
import uniq from 'lodash/uniq'
import {
  getTileStyleData,
  tilesHaveWoodFrame,
} from '../../../services/tilesStyling'
import { PRODUCT_TYPES } from '../../../services/ProductTypeState'

class PhotosOrderSummary extends Component {
  constructor(props) {
    super(props)
    this.state = {
      showAddPromoCodeDialog: false,
    }
  }

  // Discount is not supported for Value Gift Card
  _isDiscountSupported = () => {
    return !this._isValueGiftCard()
  }

  _isValueGiftCard = () => {
    const { data } = this.props
    const { summaryItems } = data
    return summaryItems?.find((p) => p.productId === ProductIds.GIFT_CARD_VALUE)
  }

  _addPromoFromCheckoutEnabled = () => {
    return (
      !isGiftCardOrder(this.props.productType) &&
      this._isDiscountSupported() &&
      !promoCodeManager.hasDiscountCoupon() &&
      !this.props.data.discountType
    )
  }

  renderGiftPriceWithCrossedDiscount() {
    const { data } = this.props
    const { productTotalPriceBeforeDiscount, productTotalPrice } = data
    const description = getGiftCardDescription(data)

    return (
      <PriceWithCrossedDiscount
        description={description}
        detailedDescription={
          this._isValueGiftCard()
            ? ''
            : getDiscountDescription({
                discountData: data,
                priceBeforeDiscount: productTotalPriceBeforeDiscount,
                priceAfterDiscount: productTotalPrice,
              })
        }
        priceBeforeDiscount={productTotalPriceBeforeDiscount}
        priceAfterDiscount={productTotalPrice}
        currency={data.currency}
      />
    )
  }

  initializeAccumulator(frameColors) {
    return Object.values(frameColors).reduce((acc, color) => {
      acc[color] = []
      return acc
    }, {})
  }

  getMixedFramesOrSizesDescription(tiles) {
    const firstSize = tiles[0].tileSize
    const areAllSameSize = tiles.every(({ tileSize }) => tileSize === firstSize)
    if (areAllSameSize) {
      const sizeText = getOrderSummarySizeText(firstSize)
      return `${tiles.length} ${t
        .get('product_selection.tiles_name')
        .toLowerCase()}${sizeText}, ${t.get(
        'order.checkout.payment_summary_rows.mixed_frames'
      )}`
    } else {
      return `${tiles.length} ${t
        .get('product_selection.tiles_name')
        .toLowerCase()}, ${t.get(
        'order.checkout.payment_summary_rows.mixed_sizes_and_frames'
      )}`
    }
  }

  renderFramedTilesPriceWithCrossedDiscount() {
    const { data } = this.props
    const tilesByColor = data.products.reduce((acc, tile) => {
      const color = tile?.pricingProduct?.frameColor
      if (color && acc[color]) {
        acc[color].push(tile)
      }
      return acc
    }, this.initializeAccumulator(FRAME_COLORS))

    return (
      <>
        {Object.entries(tilesByColor).map(([frameColor, tiles]) => {
          if (tiles.length === 0 || frameColor === FRAME_COLORS.NONE) {
            return
          }
          let description =
            tiles.length === 1
              ? `1 ${frameColor} tile`
              : `${tiles.length} ${frameColor} tiles`
          if (getTilesMaterials(tiles).length === 1) {
            const sizes = uniq(tiles.map((t) => t.pricingProduct?.tileSize))
            if (sizes.length === 1) {
              const sizeText = getOrderSummarySizeText(sizes[0])
              description = `${description}${sizeText}`
            } else {
              const sizeText = getOrderSummarySizeText(MIXED_SIZES)
              description = `${description}${sizeText}`
            }
          }
          const priceBeforeDiscount = tiles.reduce(
            (acc, tile) => acc + (tile.priceBeforeDiscount ?? 0),
            0
          )
          const priceAfterDiscount = tiles.reduce(
            (acc, tile) => acc + (tile.priceAfterDiscount ?? 0),
            0
          )
          return (
            <PriceWithCrossedDiscount
              key={description}
              description={description}
              priceBeforeDiscount={priceBeforeDiscount}
              priceAfterDiscount={priceAfterDiscount}
              currency={data.currency}
            />
          )
        })}
      </>
    )
  }

  renderTilesPriceWithCrossedDiscount() {
    const { data, tiles } = this.props
    // There are cases that we wouldn't render this component. Probably because it
    // will be rendered somewhere else (for example renderMinOrderSizeLineItem())
    const shouldRenderPriceWithCrossedDiscount =
      data.totalTiles > 0 &&
      !data.minTilesForDiscountPrice &&
      (data.additionalTilesSize ||
        (data.bundlePriceData && data.bundlePriceData.bundlePriceTilesCount) ||
        data.discountPercent === 100) &&
      !data.minOrderSize
    if (!shouldRenderPriceWithCrossedDiscount) {
      return null
    } else {
      // Generate description. Example: 3 tiles, 8''x11'' (15% off)
      let description = ''
      const nonCenterpieceTiles = tiles.filter((tile) => !isCenterpiece(tile))
      if (nonCenterpieceTiles.length === 0) {
        return null
      }
      const uniqueFrameColors = uniq(
        nonCenterpieceTiles.map((tile) => getTileStyleData(tile).frameColor)
      )
      const isMixedDescription =
        getTilesMaterials(nonCenterpieceTiles).length > 1 ||
        uniqueFrameColors.length > 1
      if (isMixedDescription) {
        description = this.getMixedFramesOrSizesDescription(nonCenterpieceTiles)
      } else if (getTileMaterialType(tiles[0]) === MATERIAL_TYPES.CANVAS) {
        description =
          data.totalTiles === 1
            ? t.get('order.checkout.payment_summary_rows.canvas_tile')
            : t.get('order.checkout.payment_summary_rows.canvas_tiles', {
                v1: data.totalTiles,
              })
      } else if (getTileMaterialType(tiles[0]) === MATERIAL_TYPES.WIDE_FRAME) {
        const frameColor = getTileStyleData(nonCenterpieceTiles[0])?.frameColor
        const colorName = frameColor
          ? t.get(`order.frame_colors.${frameColor}`).toLowerCase()
          : ''
        description =
          data.totalTiles === 1
            ? t.get('order.checkout.payment_summary_rows.wide_frame_tile', {
                color: colorName,
              })
            : t.get('order.checkout.payment_summary_rows.wide_frame_tiles', {
                v1: data.totalTiles,
                color: colorName,
              })
      } else {
        const frameColor = getTileStyleData(nonCenterpieceTiles[0])?.frameColor
        const colorName = frameColor
          ? t.get(`order.frame_colors.${frameColor}`).toLowerCase()
          : ''
        description =
          data.totalTiles === 1
            ? t.get('order.checkout.payment_summary_rows.one_color_tile', {
                color: colorName,
              })
            : t.get('order.checkout.payment_summary_rows.color_tiles', {
                v1: data.totalTiles,
                color: colorName,
              })
      }
      if (!isMixedDescription && getTilesMaterials(tiles).length === 1) {
        const sizes = uniq(nonCenterpieceTiles.map((tile) => tile.tileSize))
        const sizeText = getOrderSummarySizeText(
          sizes.length === 1 ? sizes[0] : MIXED_SIZES
        )
        description = `${description}${sizeText}`
      }
      if (data.freeTiles) {
        const freeTilesDescription =
          data.freeTiles > 1
            ? t.get('order.checkout.payment_summary_rows.are_free', {
                v1: data.freeTiles,
              })
            : t.get('order.checkout.payment_summary_rows.is_free')
        description = `${description} (${freeTilesDescription})`
      }
      const priceBeforeDiscount = data.tilePriceBeforeDiscount
      const priceAfterDiscount =
        data.tilePriceAfterDiscount != null
          ? data.tilePriceAfterDiscount
          : data.priceBeforeAdditions -
            data.centerpiecesTotalPrice -
            data.tilesDiscount
      return (
        <PriceWithCrossedDiscount
          description={description}
          detailedDescription={getDiscountDescription({
            discountData: data,
            priceBeforeDiscount,
            priceAfterDiscount,
          })}
          priceBeforeDiscount={priceBeforeDiscount}
          priceAfterDiscount={priceAfterDiscount}
          currency={data.currency}
        />
      )
    }
  }

  renderPhotoBookProductLine() {
    const { data, photoBook, onUpdateProductQuantity } = this.props
    const {
      products,
      productTotalPriceBeforeDiscount: priceBeforeDiscount,
      productTotalPrice: priceAfterDiscount,
    } = data
    const { photosCount, analyticsProps } = photoBook
    const pricingProduct = products[0].pricingProduct
    const productId = products[0].productId
    const quantity = products.length
    let description =
      quantity === 1
        ? t.get(
            'order.checkout.payment_summary_rows.photo_book_description_singular',
            {
              v1: photosCount,
            }
          )
        : t.get(
            'order.checkout.payment_summary_rows.photo_book_description_plural',
            {
              v1: photosCount,
            }
          )

    // Add free books description if applicable
    if (data.freeTiles) {
      let freeBooksDescription = ''
      if (quantity <= data.freeTiles) {
        freeBooksDescription = t.get(
          'order.checkout.payment_summary_rows.all_free'
        )
      } else {
        freeBooksDescription =
          data.freeTiles > 1
            ? t.get('order.checkout.payment_summary_rows.are_free', {
                v1: data.freeTiles,
              })
            : t.get('order.checkout.payment_summary_rows.is_free')
      }
      description = `${description} - ${freeBooksDescription}`
    }
    const isDiscountSupported = [
      DISCOUNT_TYPES.PERCENT,
      DISCOUNT_TYPES.BUYOVER,
    ].includes(data.discountType)

    const detailedDescription = [
      isDiscountSupported &&
        getDiscountDescription({
          discountData: data,
          priceBeforeDiscount,
          priceAfterDiscount,
        }),
      data.discountAutomaticPercent && {
        title: t.get(
          'order.checkout.payment_summary_rows.discount_percentage_automatic',
          {
            v1: data.discountAutomaticPercent,
          }
        ),
        discountFullyApplied: true,
      },
    ].filter((x) => x)
    return (
      <>
        <ProductSummaryItem
          quantity={quantity}
          description={description}
          onPlusClick={() => {
            const newQuantity = quantity + 1
            onUpdateProductQuantity(productId, pricingProduct, newQuantity)
            photoBook.setPhotoBooksQuantity(newQuantity)
          }}
          onMinusClick={() => {
            const newQuantity = quantity - 1
            onUpdateProductQuantity(productId, pricingProduct, newQuantity)
            photoBook.setPhotoBooksQuantity(newQuantity)
          }}
          eventProperties={analyticsProps}
        />
        <PriceWithCrossedDiscount
          description={`${t.get('photo_book.size')}: ${getSizeName(
            pricingProduct.tileSize
          )}`}
          detailedDescription={detailedDescription}
          priceBeforeDiscount={priceBeforeDiscount}
          priceAfterDiscount={priceAfterDiscount}
          currency={data.currency}
        />
      </>
    )
  }

  renderProductSummaryLine() {
    if (isGiftCardOrder(this.props.productType)) {
      return this.renderGiftPriceWithCrossedDiscount()
    } else if (this.props.productType === PRODUCT_TYPES.PHOTO_BOOK) {
      return this.renderPhotoBookProductLine()
    } else {
      return this.renderTilesPriceWithCrossedDiscount()
    }
  }

  onPromoCodeChangeClicked = () => {
    analytics.track(EVENT_NAMES.CHANGE_PROMO_CODE_TAPPED, {
      Source: PROMO_CODE_SOURCE.CHECKOUT,
      Code: promoCodeManager.getDiscountCouponDisplayName() || WELCOME_COUPON,
      Type: promoCodeManager.getDiscountCouponType() || DISCOUNT_TYPES.BUNDLE,
    })
    this.setState({ showAddPromoCodeDialog: true })
    this.props.openPromoCodeDialog?.()
  }

  onRemoveGiftCardCreditClick = (code) => {
    analytics.track(EVENT_NAMES.CHECKOUT_GIFT_CARD_REMOVE_CONFIRMED)
    promoCodeManager.removeGiftCardCreditsCode(code)
  }

  getPromoCodeContent = ({ promoCode }) => {
    return `${t.get('order.checkout.promo.title')}: ${promoCode}`
  }

  renderPromoCodeInfo({ woodPricingEnabled }) {
    if (!this._isDiscountSupported()) {
      return <div className="separator" />
    }

    const discounts = this.props.pricing?.discounts
    // "WELCOME" labels a product discount, so once loaded hide the badge when the
    // only discount is shipping (e.g. strict pricing). Credits below still show.
    const noProductDiscounts =
      !discounts?.isLoading &&
      !discounts?.value.some((d) => d.type !== DISCOUNT_TYPES.SHIPPING_BUY_OVER)

    const discountCoupon = promoCodeManager.getDiscountCoupon()
    const promoCode =
      discountCoupon?.pseudonym || discountCoupon?.code || WELCOME_COUPON

    return (
      <>
        {!noProductDiscounts && (
          <>
            <SheetButton
              className={
                woodPricingEnabled
                  ? 'with-lower-text upper-border-pricing-test'
                  : 'with-lower-text upper-border'
              }
              icon={
                !woodPricingEnabled && (
                  <S.TagCheckoutIcon className="icon-image" alt="Button" />
                )
              }
              action={this.onPromoCodeChangeClicked}
              showChangeButton
              promo
            >
              {this.getPromoCodeContent({ promoCode, woodPricingEnabled })}
            </SheetButton>
            <Divider transparent margin={woodPricingEnabled ? 17 : 10} />
          </>
        )}
        {this.renderCreditsDescriptions()}
        <S.FinalCouponSeparator $woodPricingEnabled={woodPricingEnabled} />
      </>
    )
  }

  renderCartSubtotalRow() {
    const { data } = this.props
    const { productTotalPrice, productTotalPriceBeforeDiscount, currency } =
      data

    if (!productTotalPrice || productTotalPrice <= 0) {
      return null
    }

    return (
      <PriceWithCrossedDiscount
        description={t.get('order.checkout.payment_summary_rows.subtotal')}
        priceBeforeDiscount={productTotalPriceBeforeDiscount}
        priceAfterDiscount={productTotalPrice}
        currency={currency}
        testId="subtotal-summary-item"
      />
    )
  }

  renderCreditsDescriptions() {
    const { data, dialog } = this.props
    const { giftsBalances, currency } = data
    const productType = this.props.productType
    const allTileCreditsCoupons = promoCodeManager.getAllTileCredits()

    return (
      <>
        {productType !== PRODUCT_TYPES.GIFT_CARD &&
          giftsBalances?.length > 0 && (
            <>
              <Divider transparent margin={10} />
              {giftsBalances.map((giftCardBalance) => (
                <div key={giftCardBalance.code}>
                  <SheetButton
                    className="with-lower-text upper-border"
                    icon={
                      <S.PresentCheckoutIcon
                        className="icon-image"
                        alt="Button"
                      />
                    }
                    onChangeButtonClick={() => {
                      analytics.track(
                        EVENT_NAMES.CHECKOUT_GIFT_CARD_REMOVE_TAPPED
                      )
                      dialog.open(
                        <ConfirmationPopup
                          title={t.get('order.checkout.gift_card_remove_title')}
                          approveText={t.get('order.tile_actions.remove')}
                          onApprove={() => {
                            this.onRemoveGiftCardCreditClick(
                              giftCardBalance.code
                            )
                            dialog.close()
                          }}
                          dismissText={t.get('general.cancel')}
                          onDismiss={() => {
                            analytics.track(
                              EVENT_NAMES.CHECKOUT_GIFT_CARD_REMOVE_CANCELLED
                            )
                            dialog.close()
                          }}
                        />
                      )
                    }}
                    allIsClickable={false}
                    showChangeButton
                    changeButtonText={t.get('order.tile_actions.remove')}
                    promo
                  >
                    {getGiftCardCreditsDescription(giftCardBalance, currency)}
                  </SheetButton>
                  <Divider transparent margin={10} />
                </div>
              ))}
            </>
          )}
        {productType !== PRODUCT_TYPES.GIFT_CARD &&
          allTileCreditsCoupons
            .filter((coupon) =>
              productType === PRODUCT_TYPES.PHOTO_BOOK
                ? isBookCreditsCoupon(coupon)
                : !isBookCreditsCoupon(coupon)
            )
            .map((tileCreditsCoupon) => (
              <div key={tileCreditsCoupon.sourceCoupon}>
                <SheetButton
                  key={tileCreditsCoupon.sourceCoupon}
                  className="with-lower-text upper-border"
                  icon={
                    <S.PresentCheckoutIcon
                      className="icon-image"
                      alt="Button"
                    />
                  }
                  allIsClickable={false}
                  promo
                >
                  {getTilesCreditsCouponDescription(tileCreditsCoupon, t.get)}
                </SheetButton>
                <Divider transparent margin={10} />
              </div>
            ))}
      </>
    )
  }

  render() {
    const {
      data: { key: _, ...data },
      onSuccess,
      tiles,
      isCartFlow,
    } = this.props

    const materials = getTilesMaterials(tiles.filter((t) => !isCenterpiece(t)))
    const material = materials.length > 1 ? MIXED_MATERIALS : materials[0]
    const woodPricingEnabled = tilesHaveWoodFrame({
      tiles,
      material,
      mixColorPrice: this.props.pricing.mixColorPrice,
    })

    return (
      <div className="OrderSummary">
        {!isCartFlow && (
          <>
            <AddPromoCode
              showLabel={this._addPromoFromCheckoutEnabled()}
              onSuccess={onSuccess}
              onOpen={this.props.openPromoCodeDialog}
              onClose={this.props.closePromoCodeDialog}
            />
            {this.renderPromoCodeInfo({
              woodPricingEnabled,
            })}
            <TilesToAddForFreeShipping
              tilesToAddForFreeShipping={data.tilesToAddForFreeShipping}
            />
            <BuyOverMissingTiles buyOverData={data.buyOver} />

            <FreeTilesSummaryItem
              {...data}
              productType={this.props.productType}
            />

            {renderBaseTilesPriceForVariesPricingType(data)}

            {renderMinOrderSizeLineItem(data)}

            {renderAdditionalTilesPriceForVariesPricingType(data)}

            {renderAdditionalTilesPriceForMinOrderSize(data)}

            {this.renderProductSummaryLine()}

            <CenterpiecesSummaryItem
              data={data}
              woodPricingEnabled={woodPricingEnabled}
            />

            {data.orderFeePrice && (
              <MinimumOrderFeeSummaryItem
                currency={data.currency}
                orderFeePrice={data.orderFeePrice}
                minimumOrderPrice={data.minimumOrderPrice}
              />
            )}
          </>
        )}

        {isCartFlow && this.renderCreditsDescriptions()}

        {isCartFlow && this.renderCartSubtotalRow()}

        {!isGiftCardOrder(this.props.productType) && (
          <DeliveryPromiseItem
            hasAddress={this.props.hasAddress}
            deliveryPromise={this.props.deliveryPromise}
            deliveryDescription={this.props.deliveryDescription}
            shippingCost={data.shippingCost}
            isEligibleFreeShipping={data.isEligibleFreeShipping}
            shippingBuyOverData={data.shippingBuyOverData}
            currency={data.currency}
          />
        )}

        {this.props.taxSummaryItems}
        {this.props.creditUsed}
        {data.giftCardCreditItems?.length > 0 && (
          <GiftCardCreditsItem
            giftCardCreditItems={data.giftCardCreditItems}
            currency={data.currency}
          />
        )}
        <TotalPriceSummaryItem
          totalPrice={data.totalPrice}
          currency={data.currency}
        />
        <PromoCodeDialog
          source={PROMO_CODE_SOURCE.CHECKOUT}
          open={this.state.showAddPromoCodeDialog}
          onDismiss={() => {
            this.setState({ showAddPromoCodeDialog: false })
            this.props.closePromoCodeDialog?.()
          }}
        />
      </div>
    )
  }
}

export default withProductType(
  withPricing(withPhotoBookSummaryData(withDialog(PhotosOrderSummary)))
)
